import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../elementos/basicos/Header';
import Cabecera from '../elementos/basicos/Cabecera';
import CardBlog from '../elementos/basicos/CardBlog';
import { Navigate, useSearchParams } from 'react-router-dom';
import ContenedorCards from '../elementos/basicos/ContenedorCards';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Footer from '../elementos/basicos/Footer';
import { StyleSheetManager } from 'styled-components';
import styled from 'styled-components';
import CargaCards from '../elementos/eventos/CargaCards';
import { fetchPublicacionFilters } from '../../peticiones_API/Peticiones_Publicaciones';




const Blog = () => {

  const [parametrosBusqueda, setParamtrosBusqueda] = useSearchParams();
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorData, setErrorData] = useState(true);
  
  const currentPage = parseInt(parametrosBusqueda.get('page')) || 1;
  const sortOrder = parametrosBusqueda.get('order') || 'DESC';
  
  const urlPadre = window.location.pathname;


  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        setLoading(true);
        const WEBDESTINO= 2; //Id de la web de destino, en este caso TusCursosSepe tiene el id 2. ¡Tiene que ser el mismo que está en la tabla de web_destino y no se debe de cambiar...☠️!
        const response = await fetchPublicacionFilters(
          currentPage,
          {
            orderColumn: "fechaPublicacion",
            order: sortOrder
          },
          WEBDESTINO //Añadimos el parámetro del id de destino
        );       
        setData(response.data);
        setMeta(response.meta);
        setLoading(false);
      } catch (error) {
        setErrorData(error.code);
        setLoading(false);

      }
    };

    obtenerDatos();
  }, [currentPage, sortOrder, urlPadre]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= meta?.totalPages) {
      const newSearchParams = new URLSearchParams(parametrosBusqueda);
      newSearchParams.set('page', newPage.toString());
      setParamtrosBusqueda(newSearchParams);
    }
  };

  const handleSortChange = (newSort) => {
    const newSearchParams = new URLSearchParams(parametrosBusqueda);
    newSearchParams.set('order', newSort);
    newSearchParams.set('page', '1');
    setParamtrosBusqueda(newSearchParams);
  };

  const PaginationComponent = () => (
    meta && meta.totalPages > 1 && (
      <PaginationContainer>
        <NextPrevButton 
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span>←</span>
          Anterior
        </NextPrevButton>
        
        <PageInfo>
          Página <strong>{currentPage}</strong> de <strong>{meta.totalPages}</strong>
        </PageInfo>
        
        <NextPrevButton 
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === meta.totalPages}
        >
          Siguiente
          <span>→</span>
        </NextPrevButton>
      </PaginationContainer>
    )
  );

 
  return (
    <>
      <Helmet>
        <title>TusCursosSepe | Blog</title>
        <meta name="description" content="Blog de TusCursosSepe" />
        <meta property='og:image' content='%PUBLIC_URL%/favicon.ico' />
      </Helmet>
      <Header />
      <StyleSheetManager shouldForwardProp={() => true}>
        <Cabecera
          Titulo="BLOG"
          Texto_1="En nuestro blog encontrarás artículos relacionados con la formación, el empleo y el desarrollo profesional."
          Estilo_Texto_2="true"

        ></Cabecera>
      </StyleSheetManager>

      <ContenedorCards>
        <div className="container-fluid px-3">
          
          <Row className="justify-content-between align-items-center mb-3">
            <Col xs="auto">
              <Form.Select 
                value={sortOrder} 
                onChange={(e) => handleSortChange(e.target.value)}
                size="sm"
                style={{ width: '200px' }}
              >
                <option value="DESC">Más recientes</option>
                <option value="ASC">Más antiguos</option>
              </Form.Select>
            </Col>
            <Col xs="auto">
              {meta && (
                <small className="text-muted">
                  Página {currentPage} de {meta.totalPages} ({meta.total} artículos)
                </small>
              )}
            </Col>
          </Row>

          {/* Paginación superior */}
          <PaginationComponent />

          <Row className="justify-content-center">
            {loading ? (
              <CargaCards alineado="true" />
            ) : (
              errorData === "ERR_BAD_RESPONSE" ? (
                <Navigate to="/*" replace />
              ) : (
                <CardBlog elementosLista={data} noReloj="true" />
              )
            )}
          </Row>

          <PaginationComponent />

        </div>
      </ContenedorCards>

      <Footer />


    </>
  );
}


const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
`;

const NextPrevButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: 2px solid #e0e6ed;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  color: #4a5568;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  span {
    font-size: 16px;
    transition: transform 0.2s ease;
  }

  &:hover:not(:disabled) {
    border-color: #ee805d;
    transform: translateY(-1px);

    span {
      transform: translateX(-2px);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f7fafc;
    border-color: #e2e8f0;
    color: #a0aec0;
  }

  &:active:not(:disabled) {
    transform: translateY(0px);
  }
`;

const PageInfo = styled.div`
  font-size: 14px;
  color: #718096;
  margin: 0 15px;
  white-space: nowrap;

  strong {
    color: #2d3748;
    font-weight: 700;
  }
`;


export default Blog;
